import { useEffect, useState } from "react";
import "./App.css";
import { Loader } from "./components/Loader";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Checkbox,
  Button,
} from "@mui/material";

const searchStyle = {
  display: "flex",
  padding: 10,
  margin: 5,
  justifyContent: "space-between",
};

const inputStyle = {
  flexGrow: 1,
  minWidth: 180,
};

function App() {
  const [loading, setLoading] = useState<boolean>(false);
  const [generationLoading, setGenerationLoading] = useState<boolean>(false);
  const [results, setResults] = useState<any[]>([]);
  const [showContentModal, setShowContentModal] = useState<boolean>(false);
  const [visionContent, setVisionContent] = useState<string>("");
  const [visionQuery, setVisionQuery] = useState({
    author: "",
    content: "",
    denomination: "",
    save: false,
  });
  const [semanticQuery, setSemanticQuery] = useState("");
  const [tagQuery, setTagQuery] = useState<string>("");

  useEffect(() => {
    // window.scrollTo({
    //   top: 1000,
    //   behavior: "smooth",
    // });
  }, [results]);

  useEffect(() => {
    makeEmbeddingQuery([]);
  }, []);

  const makeEmbeddingQuery = async (embedding: []) => {
    setLoading(true);
    let data;
    try {
      const response = await fetch(
        process.env.REACT_APP_API_URL + "/embedding",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ embedding: embedding }),
        }
      );
      console.log("OK?");
      data = await response.json();
      console.log("WAITTTT");

      setResults(data as unknown as []);
    } catch (e) {
      alert("There was an error finding similar visions" + e);
    } finally {
      setLoading(false);
    }
    return data as unknown as [];
  };

  const generateSimilarVision = async (embedding: []) => {
    setLoading(true);
    setGenerationLoading(true);
    setShowContentModal(true);
    try {
      const similarVisions = await makeEmbeddingQuery(embedding);
      let data;
      const response = await fetch(
        process.env.REACT_APP_API_URL + "/generate",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            visions: similarVisions
              .map((vision) => {
                return (vision as any).content;
              })
              .slice(0, 2),
          }),
        }
      );
      data = await response.json();

      setVisionContent(data.vision);
    } catch (e) {
      alert("There was an error generating a similar vision");
    } finally {
      setLoading(false);
      setGenerationLoading(false);
    }
  };

  const makeQuery = async () => {
    try {
      let data;
      if (tagQuery) {
        console.log(tagQuery.split(", "));
        const response = await fetch(process.env.REACT_APP_API_URL + "/tags", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(tagQuery.split(", ")),
        });
        data = await response.json();
      } else if (semanticQuery) {
        const response = await fetch(
          process.env.REACT_APP_API_URL + "/semantic",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ text: semanticQuery }),
          }
        );
        data = await response.json();
      } else if (visionQuery.content) {
        const response = await fetch(
          process.env.REACT_APP_API_URL + "/vision",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(visionQuery),
          }
        );
        data = await response.json();
      } else {
        return;
      }
      setResults(data as unknown as []);
    } catch (e) {
      console.error(e);
      alert(
        "There was an error with your search, please try again later..." + e
      );
    } finally {
      setLoading(false);
      setSemanticQuery("");
      setTagQuery("");
      setVisionQuery({
        author: "",
        denomination: "",
        content: "",
        save: false,
      });
    }
  };

  const closeModal = () => {
    setShowContentModal(false);
    setVisionContent("");
  };

  return (
    <div className="App">
      <header className="App-header">
        <h1>Visions</h1>
        <div style={{ maxWidth: 800 }}>
          <p>
            This is a collection of visions and spiritual experiences from
            various religious figures and denominations.
          </p>
          <p>
            What I've done is tag each of these visions with the different
            qualities that appear within the vision. Additionally, I've created
            text embeddings for each vision to enable similarity search across
            visions via cosine similarity.
          </p>
          <p>
            You can search for visions by tag, semantically, or by inputting a
            vision of your own to find similar visions.
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={searchStyle}>
            Search By Tag (comma separated):
            <input
              style={inputStyle}
              value={tagQuery}
              onChange={(event) => setTagQuery(event?.target.value)}
            />
          </div>

          <div style={searchStyle}>
            Search Semantically:
            <input
              style={inputStyle}
              value={semanticQuery}
              onChange={(event) => setSemanticQuery(event.target.value)}
            />
          </div>

          <div style={{ ...searchStyle, ...{ flexDirection: "column" } }}>
            Input Your Own Vision
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
              }}
            >
              Vision Text:
              <textarea
                style={{ ...inputStyle }}
                rows={20}
                value={visionQuery.content}
                onChange={(event) => {
                  setVisionQuery({
                    ...visionQuery,
                    content: event.target.value,
                  });
                }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
              }}
            >
              Author: (optional)
              <input
                style={inputStyle}
                value={visionQuery.author}
                onChange={(event) =>
                  setVisionQuery({ ...visionQuery, author: event.target.value })
                }
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
              }}
            >
              Denomination: (optional)
              <input
                style={inputStyle}
                value={visionQuery.denomination}
                onChange={(event) => {
                  setVisionQuery({
                    ...visionQuery,
                    denomination: event.target.value,
                  });
                }}
              />
            </div>
            <div>
              {/*<div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <p>Save Vision?</p>
                <div
                  style={{
                    background: "white",
                    display: "flex",
                    justifyContent: "center",
                    padding: 20,
                  }}
                >
                  <Checkbox
                    checked={visionQuery.save}
                    onChange={(event) =>
                      setVisionQuery({
                        ...visionQuery,
                        save: !visionQuery.save,
                      })
                    }
                    inputProps={{ "aria-label": "controlled" }}
                  />
                </div>
                  </div>*/}
              {loading ? (
                <Loader />
              ) : (
                <Button
                  style={{ width: 120, margin: 5 }}
                  onClick={() => {
                    setLoading(true);
                    makeQuery();
                  }}
                >
                  Search
                </Button>
              )}
            </div>
          </div>
        </div>
      </header>
      <div>
        <h1>Results</h1>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="right">Author</TableCell>
                <TableCell align="right">Denomination</TableCell>
                <TableCell align="right">
                  Content (click to view full text)
                </TableCell>
                <TableCell align="left">Tags</TableCell>
                <TableCell align="center">Find Similar</TableCell>
                <TableCell align="center">Generate Similar</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {results.map((row) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell align="right">{row.author}</TableCell>
                  <TableCell align="right">{row.denomination}</TableCell>
                  <TableCell
                    align="right"
                    onClick={() => {
                      setVisionContent(row.content);
                      setShowContentModal(true);
                    }}
                  >
                    {row.content.slice(0, 50) + "..."}
                  </TableCell>
                  <TableCell align="left">{row.tags.join(", ")}</TableCell>
                  <TableCell>
                    <Button onClick={() => makeEmbeddingQuery(row.embedding)}>
                      Compare Similar
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button
                      onClick={() => generateSimilarVision(row.embedding)}
                    >
                      Generate Similar
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <Modal open={showContentModal} onClose={closeModal}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
          }}
          onClick={closeModal}
        >
          <div
            style={{
              maxWidth: 500,
              maxHeight: "70%",
              overflowY: "scroll",
              backgroundColor: "#202020",
              padding: 20,
              borderRadius: 20,
            }}
          >
            {loading || generationLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <Loader />
                <p style={{ color: "white" }}>
                  This may take 1-2 mins to generate
                </p>
              </div>
            ) : (
              <p style={{ color: "white" }}>{visionContent}</p>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default App;
